/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     接入点订单 接口
  | @Version:   2020-01-03  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function apOrderListApi(params) {
  return request({
    url: '?c=ap&a=order&do=list',
    method: 'get',
    params
  })
}

export function apOrderGetApi(params) {
  return request({
    url: '?c=ap&a=order&do=get',
    method: 'get',
    params
  })
}
